// ============================
// FRENCH TRANSLATIONS
// AboutSec2DataFR.js
// ============================

export const industriesDataFR = [
  {
    icon: "/assets/icons/investment.png",
    title: "Stratégie d'Investissement",
    text: "Développer des stratégies d'investissement complètes alignées sur vos objectifs et votre tolérance au risque.",
  },
  {
    icon: "/assets/icons/risk.png",
    title: "Risque et Conformité",
    text: "Cadres robustes de gestion des risques garantissant la conformité réglementaire et la protection.",
  },
  {
    icon: "/assets/icons/portfolio.png",
    title: "Optimisation de Portefeuille",
    text: "Techniques avancées de construction de portefeuille pour maximiser les rendements ajustés au risque.",
  },
  {
    icon: "/assets/icons/performance.png",
    title: "Analyse de Performance",
    text: "Mesure complète de la performance et analyse d'attribution pour des décisions éclairées.",
  },
];

export const defaultDataFR = [
  {
    icon: "assets/icons/Precision.png",
    title: "Transparence Stratégique",
    text: "Nous visons à créer des organisations où la clarté financière est conçue grâce à l'analyse prédictive et à des modèles de gouvernance résilients.",
  },
  {
    icon: "assets/icons/Swift.png",
    title: "Croissance Résiliente",
    text: "Notre vision est d'aider les entreprises à se développer grâce à des structures qui équilibrent l'efficacité du capital, l'optimisation des risques et l'adaptabilité du marché.",
  },
  {
    icon: "assets/icons/GrowthwithIntegrity.png",
    title: "Leadership d'Intégrité",
    text: "Nous nous efforçons de définir de nouvelles normes en matière d'éthique consultative grâce à une pensée indépendante et à des conseils fondés sur des preuves.",
  },
];

export const healthcareDataFR = [
  {
    icon: "/assets/icons/investment.png",
    title: "Optimisation des Soins",
    text: "Évaluation des processus cliniques pour réduire les inefficacités, améliorer le flux de patients et renforcer la qualité globale du service.",
  },
  {
    icon: "/assets/icons/risk.png",
    title: "Résilience Financière",
    text: "Nous aidons les institutions de santé à stabiliser les revenus, contrôler les coûts opérationnels et créer des plans financiers à long terme.",
  },
  {
    icon: "/assets/icons/portfolio.png",
    title: "Flux de Soins Numériques",
    text: "Aider les hôpitaux à adopter des technologies pratiques - mises à niveau DSE, automatisation, analyses pour améliorer l'expérience patient.",
  },
  {
    icon: "/assets/icons/performance.png",
    title: "Intégrité de Conformité",
    text: "Avec des exigences réglementaires simplifiées et des structures de gouvernance, nous protégeons les opérations de santé.",
  },
];

export const oilAndGasDataFR = [
  {
    icon: "/assets/icons/investment.png",
    title: "Évaluation d'Actifs",
    text: "Nous évaluons la santé financière et la valeur à long terme des actifs énergétiques pour soutenir des décisions d'investissement et de désinvestissement plus intelligentes.",
  },
  {
    icon: "/assets/icons/risk.png",
    title: "Structuration du Capital",
    text: "Nous aidons les entreprises énergétiques à optimiser les stratégies de financement, gérer les flux de capitaux et structurer les projets.",
  },
  {
    icon: "/assets/icons/portfolio.png",
    title: "Conformité Réglementaire",
    text: "Nous naviguons dans les réglementations énergétiques mondiales, les cadres de reporting et la durabilité pour garantir des opérations financières alignées et prêtes à l'audit.",
  },
  {
    icon: "/assets/icons/performance.png",
    title: "Efficacité Opérationnelle",
    text: "Nous identifions les fuites de coûts dans le traitement, le transport et la distribution, permettant aux entreprises énergétiques d'améliorer leurs marges.",
  },
];

export const powerUtilitiesSectorDataFR = [
  {
    icon: "/assets/icons/investment.png",
    title: "Analyse du Marché de l'Énergie",
    text: "Nous décodons les modèles de demande régionaux, les structures tarifaires et les changements réglementaires pour guider les décisions d'investissement et de planification.",
  },
  {
    icon: "/assets/icons/risk.png",
    title: "Conseil en Actifs",
    text: "De la modernisation du réseau aux améliorations de performance des centrales, nous aidons les services publics à améliorer la fiabilité des actifs et la valeur à long terme.",
  },
  {
    icon: "/assets/icons/portfolio.png",
    title: "Transformation Opérationnelle",
    text: "Nous rationalisons les opérations de distribution grâce à l'intégration numérique, l'automatisation et l'analyse prédictive pour une efficacité accrue.",
  },
  {
    icon: "/assets/icons/performance.png",
    title: "Support de Conformité",
    text: "Nous vous aidons à naviguer dans les lois sur l'énergie, les exigences de licence, les déclarations et les mandats de durabilité en toute confiance.",
  },
];

export const wasteManagementDataFR = [
  {
    icon: "/assets/icons/investment.png",
    title: "Perspectives d'Économie Circulaire",
    text: "Stratégies qui réduisent la production de déchets et poussent les organisations vers la réutilisation, la récupération et la durabilité.",
  },
  {
    icon: "/assets/icons/risk.png",
    title: "Alignement ESG",
    text: "Conseils pour respecter les lois locales de conformité des déchets tout en renforçant les rapports ESG et les performances environnementales.",
  },
  {
    icon: "/assets/icons/portfolio.png",
    title: "Planification Opérationnelle",
    text: "Améliorations des processus de collecte, ségrégation, recyclage et élimination pour réduire les coûts et augmenter le débit.",
  },
  {
    icon: "/assets/icons/performance.png",
    title: "Solutions Technologiques",
    text: "Conseil sur le suivi numérique, les poubelles intelligentes, l'automatisation et l'analyse qui améliorent la précision et réduisent le risque opérationnel.",
  },
];

export const miningAndMineralsDataFR = [
  {
    icon: "/assets/icons/investment.png",
    title: "Évaluation Géologique",
    text: "Aider les sociétés minières à renforcer les décisions d'investissement grâce à des informations financières claires.",
  },
  {
    icon: "/assets/icons/risk.png",
    title: "Conformité ESG",
    text: "Guider les mineurs à travers des cadres environnementaux et de sécurité stricts qui réduisent les risques à long terme.",
  },
  {
    icon: "/assets/icons/portfolio.png",
    title: "Efficacité d'Extraction",
    text: "Améliorer l'efficacité de l'extraction et réduire les déchets grâce à des évaluations opérationnelles basées sur les données.",
  },
  {
    icon: "/assets/icons/performance.png",
    title: "Risque de Matières Premières",
    text: "Renforcer la résilience à travers les canaux d'approvisionnement, de logistique et d'exportation pour la stabilité dans les marchés volatils des matières premières.",
  },
];

export const assetManagementDataFR = [
  {
    icon: "/assets/icons/investment.png",
    title: "Résilience Opérationnelle",
    text: "Les flux de travail numérisés réduisent les erreurs de traitement, rationalisent les cycles de reporting et réduisent les coûts opérationnels.",
  },
  {
    icon: "/assets/icons/risk.png",
    title: "Intelligence des Risques",
    text: "L'analyse en temps réel améliore la surveillance de l'exposition, améliore la planification de scénarios et soutient une prise de décision plus éclairée.",
  },
  {
    icon: "/assets/icons/portfolio.png",
    title: "Discipline de Portefeuille",
    text: "Des cadres d'allocation plus solides aident les gestionnaires d'actifs à réagir plus rapidement aux changements du marché et à réduire le risque de concentration.",
  },
  {
    icon: "/assets/icons/performance.png",
    title: "Clarté Client",
    text: "Une transparence accrue, des rapports simplifiés et des informations basées sur les données renforcent la fidélisation des clients sur des marchés concurrentiels.",
  },
];

export const bankingDataFR = [
  {
    icon: "/assets/icons/investment.png",
    title: "Stabilité du Crédit",
    text: "Modèles d'évaluation du crédit renforcés utilisant des déclencheurs d'alerte précoce et des données de marché pour protéger la qualité des prêts.",
  },
  {
    icon: "/assets/icons/risk.png",
    title: "Rails Numériques",
    text: "Moderniser les services bancaires de base avec des rails numériques sécurisés qui améliorent la vitesse des transactions et réduisent les frictions manuelles.",
  },
  {
    icon: "/assets/icons/portfolio.png",
    title: "Opérations Allégées",
    text: "Optimiser les réseaux d'agences et l'allocation du capital pour réaliser des réductions mesurables des coûts d'exploitation.",
  },
  {
    icon: "/assets/icons/performance.png",
    title: "Intelligence Client",
    text: "Transformer les données clients en informations exploitables qui élèvent les produits financiers et renforcent la valeur à vie.",
  },
];

export const financialAdvisoryDataFR = [
  {
    icon: "/assets/icons/investment.png",
    title: "Stratégie de Capital",
    text: "Conseils clairs sur l'allocation judicieuse des fonds, le renforcement des flux de trésorerie et la planification des investissements avec une valeur à long terme à l'esprit.",
  },
  {
    icon: "/assets/icons/risk.png",
    title: "Examen des Risques",
    text: "Évaluation simple et structurée des risques financiers avec des mesures pratiques pour réduire l'incertitude financière et protéger la performance.",
  },
  {
    icon: "/assets/icons/portfolio.png",
    title: "Perspectives de Performance",
    text: "Analyse simple qui met en évidence ce qui fonctionne, ce qui ne fonctionne pas et comment améliorer l'efficacité financière.",
  },
  {
    icon: "/assets/icons/performance.png",
    title: "Planification de Croissance",
    text: "Stratégies concrètes qui aident les entreprises à se développer durablement avec une discipline financière renforcée et des résultats prévisibles.",
  },
];

export const financialServiceTaxDataFR = [
  {
    icon: "/assets/icons/investment.png",
    title: "Précision de Conformité",
    text: "Garantir que les déclarations, divulgations et documentation répondent aux normes réglementaires sans approximation.",
  },
  {
    icon: "/assets/icons/risk.png",
    title: "Contrôle des Risques",
    text: "Identifier tôt les zones d'exposition et créer des cadres fiscaux qui réduisent les risques financiers et juridiques.",
  },
  {
    icon: "/assets/icons/portfolio.png",
    title: "Planification de Valeur",
    text: "Guider les entreprises vers des structures fiscalement efficaces qui améliorent les flux de trésorerie et la rentabilité à long terme.",
  },
  {
    icon: "/assets/icons/performance.png",
    title: "Alignement Global",
    text: "Soutenir les opérations transfrontalières avec des stratégies fiscales qui restent cohérentes à travers les juridictions.",
  },
];

export const fintechDataFR = [
  {
    icon: "/assets/icons/investment.png",
    title: "Modèles de Revenus",
    text: "Nous évaluons la tarification, les marges de transaction et la monétisation des produits pour aider les FinTechs à débloquer des flux de revenus durables.",
  },
  {
    icon: "/assets/icons/risk.png",
    title: "Contrôles des Risques",
    text: "Nous renforçons les systèmes AML/KYC, les flux de détection de fraude et les contrôles opérationnels pour garantir des opérations conformes.",
  },
  {
    icon: "/assets/icons/portfolio.png",
    title: "Intelligence des Données",
    text: "Nous utilisons l'analyse financière pour améliorer les décisions de crédit, la segmentation des clients et l'efficacité des produits.",
  },
  {
    icon: "/assets/icons/performance.png",
    title: "Systèmes Évolutifs",
    text: "Nous guidons les mises à niveau de plateforme, les écosystèmes API et l'infrastructure financière nécessaires à une expansion numérique rapide.",
  },
];

export const insuranceDataFR = [
  {
    icon: "/assets/icons/investment.png",
    title: "Modélisation des Risques",
    text: "Analyses plus précises pour améliorer la précision des prix, renforcer la souscription et réduire l'exposition dans les portefeuilles.",
  },
  {
    icon: "/assets/icons/risk.png",
    title: "Optimisation du Capital",
    text: "Cadres pratiques qui améliorent les ratios de solvabilité, allouent efficacement le capital et favorisent la stabilité à long terme.",
  },
  {
    icon: "/assets/icons/portfolio.png",
    title: "Efficacité des Processus",
    text: "Moderniser les flux de sinistres, de souscription et de polices pour réduire les délais, diminuer les coûts et améliorer les résultats clients.",
  },
  {
    icon: "/assets/icons/performance.png",
    title: "Préparation Réglementaire",
    text: "Conseils clairs et structurés pour naviguer dans les IFRS, les règles de solvabilité et les attentes de conformité en évolution avec confiance.",
  },
];

export const scienceReadyExpertiseDataFR = [
  {
    icon: "/assets/icons/risk.png",
    title: "Perspective Réglementaire",
    text: "Guider les équipes à travers les exigences FDA, EMA et régionales qui raccourcissent les délais d'approbation et réduisent les risques de conformité.",
  },
  {
    icon: "/assets/icons/portfolio.png",
    title: "Accélération des Essais",
    text: "Améliorer la conception des protocoles, la préparation des sites et les parcours patients pour réduire les délais de recrutement et obtenir des résultats cliniques plus solides.",
  },
  {
    icon: "/assets/icons/performance.png",
    title: "Efficacité des Coûts",
    text: "Aligner les dépenses de R&D, les opérations de chaîne d'approvisionnement et les priorités de portefeuille pour gérer les coûts croissants sans ralentir l'innovation.",
  },
  {
    icon: "/assets/icons/performance.png",
    title: "Préparation au Marché",
    text: "Construire des stratégies de preuves, de tarification et d'accès qui aident les nouvelles thérapies à obtenir un remboursement et à atteindre les patients plus rapidement.",
  },
];

export const privateEquityDataFR = [
  {
    icon: "/assets/icons/risk.png",
    title: "Clarté des Transactions",
    text: "Informations financières, opérationnelles et de marché plus précises qui aident les investisseurs à valider les hypothèses et à évaluer les actifs.",
  },
  {
    icon: "/assets/icons/portfolio.png",
    title: "Playbooks de Valeur",
    text: "Feuilles de route post-acquisition claires axées sur l'amélioration de l'EBITDA, la discipline des flux de trésorerie, l'efficacité numérique et l'alignement du leadership.",
  },
  {
    icon: "/assets/icons/performance.png",
    title: "Visibilité des Risques",
    text: "Analyse prospective de la conformité, de l'exposition au marché et des vulnérabilités opérationnelles pour protéger les résultats d'investissement.",
  },
  {
    icon: "/assets/icons/investment.png",
    title: "Préparation à la Sortie",
    text: "Préparation stratégique qui renforce les rapports, optimise les mesures de performance et positionne les actifs pour des valorisations plus solides.",
  },
];

export const professionalServiceDataFR = [
  {
    icon: "/assets/icons/risk.png",
    title: "Contrôle des Marges",
    text: "Optimiser la tarification, les structures de coûts et l'économie des engagements pour protéger la rentabilité à travers les cycles de demande volatiles.",
  },
  {
    icon: "/assets/icons/portfolio.png",
    title: "Excellence de Livraison",
    text: "Améliorer la gouvernance de projet, l'efficacité du flux de travail et la qualité de service pour améliorer la satisfaction et la fidélisation des clients.",
  },
  {
    icon: "/assets/icons/performance.png",
    title: "Optimisation des Talents",
    text: "Renforcer la planification des capacités, la prévision d'utilisation et le déploiement des compétences pour une main-d'œuvre plus productive.",
  },
  {
    icon: "/assets/icons/investment.png",
    title: "Accélération Numérique",
    text: "Permettre les mises à niveau CRM, l'automatisation des flux de travail et l'adoption d'analyses qui soutiennent une prise de décision plus rapide et plus intelligente.",
  },
];

export const publicSectorDataFR = [
  {
    icon: "/assets/icons/risk.png",
    title: "Discipline Fiscale",
    text: "Améliorer la précision budgétaire, minimiser les fuites et permettre une allocation des ressources basée sur les données à travers les départements.",
  },
  {
    icon: "/assets/icons/portfolio.png",
    title: "Efficacité du Service",
    text: "Rationaliser les processus, réduire les délais de traitement et améliorer la réactivité pour une meilleure expérience citoyenne.",
  },
  {
    icon: "/assets/icons/performance.png",
    title: "Modernisation Numérique",
    text: "Soutenir les plateformes d'e-gouvernance, l'automatisation et les systèmes intégrés qui améliorent la transparence et la rapidité.",
  },
  {
    icon: "/assets/icons/investment.png",
    title: "Force de Gouvernance",
    text: "Améliorer les cadres de conformité, les structures de reporting et la surveillance des performances pour réduire le risque opérationnel.",
  },
];

export const realEstateConstructionDataFR = [
  {
    icon: "/assets/icons/risk.png",
    title: "Efficacité du Capital",
    text: "Réingénierie de la circulation du capital à travers l'acquisition foncière, les approbations et les cycles de construction pour prévenir l'érosion de valeur.",
  },
  {
    icon: "/assets/icons/portfolio.png",
    title: "Optimisation de la Vitesse",
    text: "Concevoir des modèles d'exécution qui maintiennent les entrepreneurs, les matériaux et les machines en mouvement comme un système synchronisé unique.",
  },
  {
    icon: "/assets/icons/performance.png",
    title: "Actif Amélioré",
    text: "Transformer les bâtiments en actifs axés sur la performance en utilisant des diagnostics numériques et des interventions de cycle de vie.",
  },
  {
    icon: "/assets/icons/investment.png",
    title: "Bouclier de Conformité",
    text: "Intégrer les exigences environnementales et de sécurité dans la conception la plus précoce, afin que les projets restent prêts à l'approbation.",
  },
];

export const mediaAndEntertainmentDataFR = [
  {
    icon: "/assets/icons/risk.png",
    title: "Intelligence du Contenu",
    text: "Utiliser les signaux d'audience, les performances de genre et le comportement de plateforme pour guider les investissements de contenu plus intelligents et réduire le risque créatif.",
  },
  {
    icon: "/assets/icons/portfolio.png",
    title: "Architecture de Distribution",
    text: "Concevoir des stratégies de canaux OTT, sociaux et de diffusion qui renforcent l'engagement, réduisent l'attrition et élargissent la portée.",
  },
  {
    icon: "/assets/icons/performance.png",
    title: "Économie de Production",
    text: "Retravailler les budgets, les structures de fournisseurs et les flux de travail de tournage pour contrôler les coûts tout en maintenant la qualité créative.",
  },
  {
    icon: "/assets/icons/investment.png",
    title: "Ingénierie de Monétisation",
    text: "Optimiser les droits, la tarification et les accords multi-marchés pour construire des flux de revenus stables, prévisibles et diversifiés.",
  },
];

export const technologyDataFR = [
  {
    icon: "/assets/icons/risk.png",
    title: "Vélocité du Produit",
    text: "Accélérer la livraison de fonctionnalités en éliminant les obstacles d'ingénierie et en resserrant l'exécution inter-équipes.",
  },
  {
    icon: "/assets/icons/portfolio.png",
    title: "Adéquation au Marché",
    text: "Affiner la compréhension du client, les cas d'utilisation et les propositions de valeur pour stimuler l'adoption réelle.",
  },
  {
    icon: "/assets/icons/performance.png",
    title: "Moteur de Revenus",
    text: "Renforcer la tarification, l'emballage et les entonnoirs de mise sur le marché pour convertir la demande en revenus prévisibles.",
  },
  {
    icon: "/assets/icons/investment.png",
    title: "Architecture Évolutive",
    text: "Corriger le gaspillage cloud, la fragilité système et les couches de dette technique pour que les équipes puissent croître sans casser l'infrastructure.",
  },
];

export const telecommunicationDataFR = [
  {
    icon: "/assets/icons/risk.png",
    title: "Économie de Réseau",
    text: "Réduire le gaspillage de déploiement et optimiser l'utilisation 5G pour que les opérateurs investissent là où la performance et la demande se rencontrent réellement.",
  },
  {
    icon: "/assets/icons/portfolio.png",
    title: "Expérience Client",
    text: "Corriger la vraie attrition grâce à des parcours numériques plus fluides et une qualité de service qui reste cohérente pendant les pics de charge.",
  },
  {
    icon: "/assets/icons/performance.png",
    title: "Résilience des Marges",
    text: "Renforcer la rentabilité en repensant les modèles opérationnels et en alignant la tarification avec la valeur réelle du réseau.",
  },
  {
    icon: "/assets/icons/investment.png",
    title: "Stratégie de Spectre",
    text: "Transformer la planification du spectre en avantage concurrentiel grâce à une préparation d'enchères plus intelligente et une optimisation d'utilisation.",
  },
];